module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-02.b60aa17d.jpg";